<template>
  <div class="mt-10 max-w-6xl mx-auto">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>
    <div class="bg-white shadow sm:rounded-lg my-5">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Recover more sales by collecting WhatsApp opt-in from Checkout page
          (Mandatory)
        </h3>
        <div class="mt-2 sm:flex sm:items-start sm:justify-between">
          <div class="max-w-xl text-sm leading-5 text-gray-500">
            <p>
              Complete the steps in the guide and apply for approval. We will
              manually check your store checkout page to verify the changes.
            </p>
          </div>
          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <span class="inline-flex rounded-md shadow-sm">
              <button
                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                type="button"
                @click="openOptinModal"
              >
                <span
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                  >View guide</span
                >
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="Polaris-Page__Content">
      <!-- Automation Settings Section -->
      <Alert
        v-if="config.isBlockedFromSending"
        type="critical"
        text="WhatsApp has blocked your store from sending messages. To continue sending, your number and Facbeook business account needs to be approved by WhatsApp. Contact us for more details."
      >
        <template #actions>
          <button
            class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
            type="button"
            @click="openCrisp"
          >
            <span
              class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
              >Contact us</span
            >
          </button>
        </template>
      </Alert>

      <Alert
        type="critical"
        v-if="config.isCapLimitReached"
        text="Your store has reached the usage charge limit. Please click Approve charges button to resume automation."
      >
        <template #actions>
          <div class="Polaris-ButtonGroup">
            <div class="Polaris-ButtonGroup__Item">
              <button
                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                type="button"
                @click="getCapLimitIncrease"
              >
                <span
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                  >Connect account</span
                >
              </button>
            </div>
          </div>
        </template>
      </Alert>
      <div
        class="Polaris-InlineGrid"
        style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 3fr 5fr 4fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
      >
        <section
          class="Polaris-Box"
          style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
        >
          <div
            class="Polaris-BlockStack"
            style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
          >
            <h3 class="Polaris-Text--root Polaris-Text--headingMd">
              Automated abandoned cart messages
            </h3>
            <p class="Polaris-Text--root Polaris-Text--bodyMd">
              Send a reminder message if the customer hasn't completed their
              purchase. Message will be sent after 15 minutes after the checkout
              is abandoned which has the best conversion as per our data and
              statistics.
            </p>
          </div>
        </section>

        <div
          class="Polaris-ShadowBevel"
          style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
        >
          <div
            class="Polaris-Box"
            style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
          >
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
            >
              <!-- Enable Automation -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label class="Polaris-Label__Text">
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Enable automation</span
                      >
                    </label>
                  </div>
                </div>
                <VSwitch :value="config.isEnabled" @input="handleSwitch" />
                <p
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                >
                  <span v-if="!hasUsingCustomApp">
                    Automated WhatsApp messages are sent from our approved
                    WhatsApp Business API number.
                    <a class="Polaris-Link" @click="sendOwnNumber">
                      Send from own number?
                    </a>
                  </span>
                  <span class="text-blue-500 mt-2" v-if="hasUsingCustomApp"
                    >Automated messages are sent from your brand name and
                    number</span
                  >
                </p>
              </div>

              <!-- Phone Number -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label class="Polaris-Label__Text">
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Phone Number</span
                      >
                    </label>
                  </div>
                </div>
                <vue-tel-input
                  :value="phoneNumber"
                  :disabledFetchingCountry="true"
                  mode="international"
                  @input="handlePhoneNumberUpdate"
                />
                <p
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--subdued"
                >
                  We will share this number as a link where customers can reply
                  to you if they have any concerns.
                </p>
              </div>

              <!-- Language Selection -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label
                      id="languageSelectLabel"
                      for="languageSelect"
                      class="Polaris-Label__Text"
                    >
                      <span class="Polaris-Text--root Polaris-Text--bodyMd"
                        >Language</span
                      >
                    </label>
                  </div>
                </div>
                <div class="Polaris-Select">
                  <select
                    id="languageSelect"
                    class="Polaris-Select__Input"
                    v-model="config.messageLanguage"
                    aria-invalid="false"
                  >
                    <option
                      v-for="(language, index) in templates"
                      :key="index"
                      :value="language.elementName"
                      >{{ language.name }}</option
                    >
                  </select>
                  <div class="Polaris-Select__Content" aria-hidden="true">
                    <span class="Polaris-Select__SelectedOption">
                      {{
                        templates.find(
                          t => t.elementName === config.messageLanguage
                        )?.name
                      }}
                    </span>
                    <span class="Polaris-Select__Icon">
                      <span class="Polaris-Icon">
                        <svg
                          viewBox="1 1 18 18"
                          class="Polaris-Icon__Svg"
                          focusable="false"
                          aria-hidden="true"
                        >
                          <path
                            d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z"
                          ></path>
                          <path
                            d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                  </div>
                  <div class="Polaris-Select__Backdrop"></div>
                </div>
              </div>

              <!-- Message Template -->
              <div class="">
                <div class="Polaris-Labelled__LabelWrapper">
                  <div class="Polaris-Label">
                    <label
                      id="messageTemplateLabel"
                      for="messageTemplate"
                      class="Polaris-Label__Text"
                    >
                      <span class="Polaris-Text--root Polaris-Text--bodyMd">
                        Message
                        <a
                          class="Polaris-Link"
                          @click="customizeMessage('abandoned_cart')"
                        >
                          Customize the message?
                        </a>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="Polaris-Connected">
                  <div
                    class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                  >
                    <div
                      class="Polaris-TextField Polaris-TextField--hasValue Polaris-TextField--multiline"
                    >
                      <textarea
                        id="messageTemplate"
                        class="Polaris-TextField__Input"
                        :value="currentTemplate"
                        rows="8"
                        aria-labelledby="messageTemplateLabel"
                        aria-invalid="false"
                        aria-multiline="true"
                        disabled
                      ></textarea>
                      <div class="Polaris-TextField__Backdrop"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Discount Coupon Section -->
              <div class="">
                <label
                  class="Polaris-Choice Polaris-Checkbox__ChoiceLabel"
                  for="discountCheckbox_1"
                >
                  <span class="Polaris-Choice__Control">
                    <span class="Polaris-Checkbox">
                      <input
                        id="discountCheckbox_1"
                        type="checkbox"
                        class="Polaris-Checkbox__Input"
                        v-model="config.includeDiscountCoupon"
                        aria-invalid="false"
                        role="checkbox"
                        :aria-checked="config.includeDiscountCoupon"
                      />
                      <span class="Polaris-Checkbox__Backdrop"></span>
                      <span class="Polaris-Checkbox__Icon">
                        <span class="Polaris-Icon">
                          <svg
                            viewBox="0 0 20 20"
                            class="Polaris-Icon__Svg"
                            focusable="false"
                            aria-hidden="true"
                          >
                            <path
                              d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"
                            ></path>
                          </svg>
                        </span>
                      </span>
                    </span>
                  </span>
                  <span class="Polaris-Choice__Label">Include coupon code</span>
                </label>

                <!-- Coupon Code Input -->
                <div
                  v-if="config.includeDiscountCoupon"
                  class="Polaris-FormLayout"
                >
                  <div class="Polaris-FormLayout__Item">
                    <div class="Polaris-Labelled__LabelWrapper">
                      <div class="Polaris-Label">
                        <label
                          id="couponCodeLabel"
                          for="couponCode"
                          class="Polaris-Label__Text"
                        >
                          Coupon code
                        </label>
                      </div>
                    </div>
                    <div class="Polaris-Connected">
                      <div
                        class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                      >
                        <div class="Polaris-TextField">
                          <input
                            id="couponCode"
                            class="Polaris-TextField__Input"
                            v-model="config.couponCode"
                            placeholder="10OFFNEW"
                            aria-labelledby="couponCodeLabel"
                            aria-invalid="false"
                          />
                          <div class="Polaris-TextField__Backdrop"></div>
                        </div>
                      </div>
                    </div>
                    <div class="Polaris-Labelled__HelpText">
                      Create coupon codes from your
                      <a
                        class="Polaris-Link"
                        :href="discountUrl"
                        target="_blank"
                      >
                        Shopify admin > Discounts
                      </a>
                      . The coupon code will be automatically applied when
                      customers click the link in the message.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <WhatsappMessagePreview
            :template="getTemplate(config.messageLanguage)"
          ></WhatsappMessagePreview>
        </div>
      </div>
    </div>

    <div
      v-if="
        config.additionalAbandonedCartReminder &&
          config.storeId != '63f0fc4830bf7e719d46f889'
      "
    >
      <div class="Polaris-Page__Content">
        <div
          class="Polaris-InlineGrid"
          style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 3fr 5fr 4fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
        >
          <section
            class="Polaris-Box"
            style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
          >
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
            >
              <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                Second Follow up Reminder
              </h2>
              <p class="Polaris-Text--root Polaris-Text--bodyMd">
                Send a follow-up reminder message if the customer hasn't
                completed their purchase after the first reminder.
              </p>
            </div>
          </section>

          <div
            class="Polaris-ShadowBevel"
            style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
              >
                <div class="Polaris-FormLayout">
                  <div class="Polaris-FormLayout__Item">
                    <div
                      class="Polaris-LegacyStack Polaris-LegacyStack--vertical"
                    >
                      <div class="Polaris-LegacyStack__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text">Enable</label>
                          </div>
                        </div>
                        <VSwitch
                          :value="
                            config.additionalAbandonedCartReminder.isEnabled
                          "
                          @input="handleFirstFollowup"
                        />
                      </div>

                      <div class="Polaris-LegacyStack__Item">
                        <div class="Polaris-FormLayout">
                          <div class="Polaris-FormLayout__Item">
                            <div class="Polaris-Labelled__LabelWrapper">
                              <div class="Polaris-Label">
                                <label class="Polaris-Label__Text"
                                  >Follow Up Reminder Timing</label
                                >
                              </div>
                            </div>
                            <div class="Polaris-Connected">
                              <div
                                class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                              >
                                <div class="Polaris-TextField">
                                  <input
                                    class="Polaris-TextField__Input"
                                    type="text"
                                    placeholder="number between 1 - 70"
                                    v-model="
                                      config.additionalAbandonedCartReminder
                                        .sendAfterHours
                                    "
                                  />
                                  <div
                                    class="Polaris-TextField__Backdrop"
                                  ></div>
                                </div>
                              </div>
                              <div class="Polaris-Connected__Item">
                                <div class="Polaris-TextField">
                                  <div class="Polaris-TextField__Prefix">
                                    hours after checkout abandoned
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="Polaris-FormLayout__Item">
                            <div class="Polaris-Labelled__LabelWrapper">
                              <div class="Polaris-Label">
                                <label class="Polaris-Label__Text"
                                  >Language</label
                                >
                              </div>
                            </div>
                            <div class="Polaris-Select">
                              <select
                                class="Polaris-Select__Input"
                                v-model="
                                  config.additionalAbandonedCartReminder
                                    .messageLanguage
                                "
                              >
                                <option
                                  v-for="(language, index) in templates"
                                  :key="index"
                                  :value="language.elementName"
                                  >{{ language.name }}</option
                                >
                              </select>
                              <div
                                class="Polaris-Select__Content"
                                aria-hidden="true"
                              >
                                <span class="Polaris-Select__SelectedOption">{{
                                  config.additionalAbandonedCartReminder
                                    .messageLanguage
                                }}</span>
                                <span class="Polaris-Select__Icon">
                                  <span class="Polaris-Icon">
                                    <span
                                      class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                    >
                                      Select language
                                    </span>
                                  </span>
                                </span>
                              </div>
                              <div class="Polaris-Select__Backdrop"></div>
                            </div>
                          </div>

                          <div class="Polaris-FormLayout__Item">
                            <div class="Polaris-Labelled__LabelWrapper">
                              <div class="Polaris-Label">
                                <label class="Polaris-Label__Text">
                                  Message
                                  <button
                                    class="Polaris-Button Polaris-Button--plain"
                                    @click="
                                      customizeMessage('abandoned_cart_2')
                                    "
                                  >
                                    <a class="Polaris-Link"
                                      >Customize the message?</a
                                    >
                                  </button>
                                </label>
                              </div>
                            </div>
                            <div class="Polaris-Connected">
                              <div
                                class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                              >
                                <div
                                  class="Polaris-TextField Polaris-TextField--hasValue"
                                >
                                  <textarea
                                    class="Polaris-TextField__Input"
                                    :value="
                                      getTemplateMessage(
                                        config.additionalAbandonedCartReminder
                                          .messageLanguage
                                      )
                                    "
                                    disabled
                                    rows="8"
                                  ></textarea>
                                  <div
                                    class="Polaris-TextField__Backdrop"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Discount Coupon Section for Second Followup -->
                          <div class="Polaris-FormLayout__Item">
                            <label
                              class="Polaris-Choice Polaris-Checkbox__ChoiceLabel"
                              for="discountCheckbox_2"
                            >
                              <span class="Polaris-Choice__Control">
                                <span class="Polaris-Checkbox">
                                  <input
                                    id="discountCheckbox_2"
                                    type="checkbox"
                                    class="Polaris-Checkbox__Input"
                                    v-model="
                                      config.additionalAbandonedCartReminder
                                        .includeDiscountCoupon
                                    "
                                    aria-invalid="false"
                                    role="checkbox"
                                    :aria-checked="
                                      config.additionalAbandonedCartReminder
                                        .includeDiscountCoupon
                                    "
                                  />
                                  <span
                                    class="Polaris-Checkbox__Backdrop"
                                  ></span>
                                  <span class="Polaris-Checkbox__Icon">
                                    <span class="Polaris-Icon">
                                      <svg
                                        viewBox="0 0 20 20"
                                        class="Polaris-Icon__Svg"
                                        focusable="false"
                                        aria-hidden="true"
                                      >
                                        <path
                                          d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"
                                        ></path>
                                      </svg>
                                    </span>
                                  </span>
                                </span>
                              </span>
                              <span class="Polaris-Choice__Label"
                                >Include coupon code</span
                              >
                            </label>
                            <!-- Coupon Code Input for Second Followup -->
                            <div class="Polaris-FormLayout">
                              <div class="Polaris-FormLayout__Item">
                                <div class="Polaris-Labelled__LabelWrapper">
                                  <div class="Polaris-Label">
                                    <label
                                      id="couponCodeLabel2"
                                      for="couponCode2"
                                      class="Polaris-Label__Text"
                                    >
                                      Coupon code
                                    </label>
                                  </div>
                                </div>
                                <div class="Polaris-Connected">
                                  <div
                                    class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                                  >
                                    <div class="Polaris-TextField">
                                      <input
                                        id="couponCode2"
                                        class="Polaris-TextField__Input"
                                        v-model="
                                          config.additionalAbandonedCartReminder
                                            .couponCode
                                        "
                                        placeholder="10OFFNEW"
                                        aria-labelledby="couponCodeLabel2"
                                        aria-invalid="false"
                                      />
                                      <div
                                        class="Polaris-TextField__Backdrop"
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="Polaris-Labelled__HelpText">
                                  Create coupon codes from your
                                  <a
                                    class="Polaris-Link"
                                    :href="discountUrl"
                                    target="_blank"
                                  >
                                    Shopify admin > Discounts
                                  </a>
                                  The coupon code will be automatically applied
                                  when customers click the link in the message.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <WhatsappMessagePreview
              v-if="config.additionalAbandonedCartReminder"
              :template="
                getTemplate(
                  config.additionalAbandonedCartReminder.messageLanguage
                )
              "
            ></WhatsappMessagePreview>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        config.additionalAbandonedCartReminder &&
          config.storeId != '63f0fc4830bf7e719d46f889'
      "
    >
      <div class="Polaris-Page__Content">
        <div
          class="Polaris-InlineGrid"
          style="--pc-inline-grid-grid-template-columns-xs: 1fr; --pc-inline-grid-grid-template-columns-md: 3fr 5fr 4fr; --pc-inline-grid-gap-xs: var(--p-space-400); margin-top: var(--p-space-500);"
        >
          <section
            class="Polaris-Box"
            style="--pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-start-sm: var(--p-space-0); --pc-box-padding-inline-end-xs: var(--p-space-400); --pc-box-padding-inline-end-sm: var(--p-space-0);"
          >
            <div
              class="Polaris-BlockStack"
              style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
            >
              <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                Third Follow up Reminder
              </h2>
              <p class="Polaris-Text--root Polaris-Text--bodyMd">
                Send a follow-up reminder message if the customer hasn't
                completed their purchase after the second reminder.
              </p>
            </div>
          </section>

          <div
            class="Polaris-ShadowBevel"
            style='--pc-shadow-bevel-z-index: 32; --pc-shadow-bevel-content-xs: ""; --pc-shadow-bevel-box-shadow-xs: var(--p-shadow-100); --pc-shadow-bevel-border-radius-xs: var(--p-border-radius-300);'
          >
            <div
              class="Polaris-Box"
              style="--pc-box-background: var(--p-color-bg-surface); --pc-box-min-height: 100%; --pc-box-overflow-x: clip; --pc-box-overflow-y: clip; --pc-box-padding-block-start-xs: var(--p-space-400); --pc-box-padding-block-end-xs: var(--p-space-400); --pc-box-padding-inline-start-xs: var(--p-space-400); --pc-box-padding-inline-end-xs: var(--p-space-400);"
            >
              <div
                class="Polaris-BlockStack"
                style="--pc-block-stack-order: column; --pc-block-stack-gap-xs: var(--p-space-400);"
              >
                <div class="Polaris-FormLayout">
                  <div class="Polaris-FormLayout__Item">
                    <div
                      class="Polaris-LegacyStack Polaris-LegacyStack--vertical"
                    >
                      <div class="Polaris-LegacyStack__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text">Enable</label>
                          </div>
                        </div>
                        <VSwitch
                          :value="
                            config.additionalAbandonedCartReminder
                              .isThirdMessageEnabled
                          "
                          @input="handleSecondFollowup"
                        />
                      </div>

                      <div class="Polaris-LegacyStack__Item">
                        <div class="Polaris-FormLayout">
                          <div class="Polaris-FormLayout__Item">
                            <div class="Polaris-Labelled__LabelWrapper">
                              <div class="Polaris-Label">
                                <label class="Polaris-Label__Text"
                                  >Follow Up Reminder Timing</label
                                >
                              </div>
                            </div>
                            <div class="Polaris-Connected">
                              <div
                                class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                              >
                                <div class="Polaris-TextField">
                                  <input
                                    class="Polaris-TextField__Input"
                                    type="text"
                                    placeholder="number between 1 - 70"
                                    v-model="
                                      config.additionalAbandonedCartReminder
                                        .thirdMessageTiming
                                    "
                                  />
                                  <div
                                    class="Polaris-TextField__Backdrop"
                                  ></div>
                                </div>
                              </div>
                              <div class="Polaris-Connected__Item">
                                <div class="Polaris-TextField">
                                  <div class="Polaris-TextField__Prefix">
                                    hours after checkout abandoned
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="Polaris-FormLayout__Item">
                            <div class="Polaris-Labelled__LabelWrapper">
                              <div class="Polaris-Label">
                                <label class="Polaris-Label__Text"
                                  >Language</label
                                >
                              </div>
                            </div>
                            <div class="Polaris-Select">
                              <select
                                class="Polaris-Select__Input"
                                v-model="
                                  config.additionalAbandonedCartReminder
                                    .thirdMessageLanguage
                                "
                              >
                                <option
                                  v-for="(language, index) in templates"
                                  :key="index"
                                  :value="language.elementName"
                                  >{{ language.name }}</option
                                >
                              </select>
                              <div
                                class="Polaris-Select__Content"
                                aria-hidden="true"
                              >
                                <span class="Polaris-Select__SelectedOption">
                                  {{
                                    config.additionalAbandonedCartReminder
                                      .thirdMessageLanguage
                                  }}
                                </span>
                                <span class="Polaris-Select__Icon">
                                  <span class="Polaris-Icon">
                                    <svg
                                      viewBox="0 0 20 20"
                                      class="Polaris-Icon__Svg"
                                      focusable="false"
                                      aria-hidden="true"
                                    >
                                      <path
                                        d="M10 16l-4-4h8l-4 4zm0-12l4 4H6l4-4z"
                                      ></path>
                                    </svg>
                                  </span>
                                </span>
                              </div>
                              <div class="Polaris-Select__Backdrop"></div>
                            </div>
                          </div>

                          <div class="Polaris-FormLayout__Item">
                            <div class="Polaris-Labelled__LabelWrapper">
                              <div class="Polaris-Label">
                                <label class="Polaris-Label__Text">
                                  Message
                                  <button
                                    class="Polaris-Button Polaris-Button--plain"
                                    @click="
                                      customizeMessage('abandoned_cart_3')
                                    "
                                  >
                                    <a class="Polaris-Link">
                                      Customize the message?
                                    </a>
                                  </button>
                                </label>
                              </div>
                            </div>
                            <div class="Polaris-Connected">
                              <div
                                class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                              >
                                <div
                                  class="Polaris-TextField Polaris-TextField--hasValue"
                                >
                                  <textarea
                                    class="Polaris-TextField__Input"
                                    :value="
                                      getTemplateMessage(
                                        config.additionalAbandonedCartReminder
                                          .thirdMessageLanguage
                                      )
                                    "
                                    disabled
                                    rows="8"
                                  ></textarea>
                                  <div
                                    class="Polaris-TextField__Backdrop"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Discount Coupon Section for Third Followup -->
                          <div class="Polaris-FormLayout__Item">
                            <!-- Coupon Code Input for Third Followup -->
                            <label
                              class="Polaris-Choice Polaris-Checkbox__ChoiceLabel"
                              for="discountCheckbox_3"
                            >
                              <span class="Polaris-Choice__Control">
                                <span class="Polaris-Checkbox">
                                  <input
                                    id="discountCheckbox_3"
                                    type="checkbox"
                                    class="Polaris-Checkbox__Input"
                                    v-model="
                                      config.additionalAbandonedCartReminder
                                        .includeThirdMessageDiscountCoupon
                                    "
                                    aria-invalid="false"
                                    role="checkbox"
                                    :aria-checked="
                                      config.additionalAbandonedCartReminder
                                        .includeThirdMessageDiscountCoupon
                                    "
                                  />
                                  <span
                                    class="Polaris-Checkbox__Backdrop"
                                  ></span>
                                  <span class="Polaris-Checkbox__Icon">
                                    <span class="Polaris-Icon">
                                      <svg
                                        viewBox="0 0 20 20"
                                        class="Polaris-Icon__Svg"
                                        focusable="false"
                                        aria-hidden="true"
                                      >
                                        <path
                                          d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"
                                        ></path>
                                      </svg>
                                    </span>
                                  </span>
                                </span>
                              </span>
                              <span class="Polaris-Choice__Label"
                                >Include coupon code</span
                              >
                            </label>
                            <div class="Polaris-FormLayout">
                              <div class="Polaris-FormLayout__Item">
                                <div class="Polaris-Labelled__LabelWrapper">
                                  <div class="Polaris-Label">
                                    <label
                                      id="couponCodeLabel3"
                                      for="couponCode3"
                                      class="Polaris-Label__Text"
                                    >
                                      Coupon code
                                    </label>
                                  </div>
                                </div>
                                <div class="Polaris-Connected">
                                  <div
                                    class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                                  >
                                    <div class="Polaris-TextField">
                                      <input
                                        id="couponCode3"
                                        class="Polaris-TextField__Input"
                                        v-model="
                                          config.additionalAbandonedCartReminder
                                            .thirdMessageCoupon
                                        "
                                        placeholder="10OFFNEW"
                                        aria-labelledby="couponCodeLabel3"
                                        aria-invalid="false"
                                      />
                                      <div
                                        class="Polaris-TextField__Backdrop"
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                                <div class="Polaris-Labelled__HelpText">
                                  Create coupon codes from your
                                  <a
                                    class="Polaris-Link"
                                    :href="discountUrl"
                                    target="_blank"
                                  >
                                    Shopify admin > Discounts
                                  </a>
                                  The coupon code will be automatically applied
                                  when customers click the link in the message.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <WhatsappMessagePreview
              v-if="config.additionalAbandonedCartReminder"
              :template="
                getTemplate(
                  config.additionalAbandonedCartReminder.thirdMessageLanguage
                )
              "
            ></WhatsappMessagePreview>
          </div>
        </div>
      </div>
    </div>
    <OwnNumberForm
      v-if="showOwnNumberForm"
      :feautureType="feautureType"
      @close="showOwnNumberForm = false"
    />
    <TemplateApprovalForm
      :templateType="templateApprovalType"
      v-if="showTemplateApprovalForm"
      @close="showTemplateApprovalForm = false"
    />
    <AdvancedPlanAlert
      v-if="showAdvancedPlanAlert"
      :feautureType="feautureType"
      @close="showAdvancedPlanAlert = false"
    />
    <Notification :text="notificationText" :show="showNotification" />
    <OptinOnboardingModal
      v-if="showModal"
      :feautureType="feautureType"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import VSwitch from "../../components/Common/VSwitch";
import Notification from "../../components/Common/Notification";
import OptinOnboardingModal from "../../components/Common/OptinOnboardingModal.vue";
import OwnNumberForm from "../../components/Forms/OwnNumberForm.vue";
import TemplateApprovalForm from "../../components/Forms/TemplateApprovalForm.vue";
import AdvancedPlanAlert from "../../components/Forms/AdvancedPlanAlert.vue";
import { cloneDeep, isEqual } from "lodash-es";
import Alert from "../../components/Common/Alert.vue";
import WhatsappMessagePreview from "../../components/Common/WhatsappMessagePreview.vue";

import customApp from "../../Mixins/customApp";

export default {
  name: "AutomatedConfigureForm",
  mixins: [customApp],
  components: {
    VueTelInput,
    Alert,
    VSwitch,
    Notification,
    OptinOnboardingModal,
    OwnNumberForm,
    TemplateApprovalForm,
    AdvancedPlanAlert,
    WhatsappMessagePreview
  },

  data() {
    return {
      phoneNumber: "",
      notificationText: "",
      showNotification: false,
      config: {},
      originalConfig: {},
      templates: [],
      showModal: false,
      showOwnNumberForm: false,
      showTemplateApprovalForm: false,
      showAdvancedPlanAlert: false,
      feautureType: "custom_template",
      templateApprovalType: "abandoned_cart",
      saveBar: null,
      isLoading: false
    };
  },

  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },

  computed: {
    currentTemplate() {
      const template = this.templates.find(
        template => template.elementName === this.config.messageLanguage
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    discountUrl() {
      const { shopOrigin } = this.$store.getters.getStore;
      return `https://${shopOrigin}/admin/discounts/`;
    }
  },

  created() {
    this.init();
    this.updateOnboadingFlag();
    this.checkForCustomApp();
  },

  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },

  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.config = response.config;
        this.originalConfig = cloneDeep(response.config);
        this.templates = response.templates;
        this.phoneNumber = this.config.phoneNumber;
        this.isLoading = false;
      });
    },

    checkForChanges() {
      if (!isEqual(this.config, this.originalConfig)) {
        this.saveBar.show();
      } else {
        this.saveBar.hide();
      }
    },

    onSaveBarSaveClicked() {
      this.save();
      this.saveBar.hide();
    },

    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    },

    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, event) {
      // if (isValid) {
      // console.log(number, isValid, country);
      if (this.config.phoneNumber != event.number && event.number) {
        this.config.phoneNumber = event.number;
      }
      // }
    },
    save() {
      if (this.hasMoreCharacters) {
        this.onAutomationSaveValidationError(
          "Button Label should be less than 12 characters"
        );
        return;
      }
      if (
        this.config.includeDiscountCoupon &&
        (!this.config.couponCode || this.config.couponCode.length == 0)
      ) {
        this.onAutomationSaveValidationError("Please add a discount code");
        return;
      }

      this.updateConfig();
    },
    onAutomationSaveValidationError(alertMessage) {
      alert(alertMessage);
    },
    handleSwitch(value) {
      this.config.isEnabled = value;
    },
    handleFirstFollowup(value) {
      this.$store.dispatch("hasUsingCustomApp").then(response => {
        if (response.hasCustomApp) {
          this.config.additionalAbandonedCartReminder.isEnabled = value;
        } else {
          this.feautureType = "followup_reminder";
          this.sendOwnNumber();
        }
      });
      if (value === false) {
        this.config.additionalAbandonedCartReminder.isEnabled = value;
        this.updateConfig();
      }
    },
    handleSecondFollowup(value) {
      this.$store.dispatch("hasUsingCustomApp").then(response => {
        if (response.hasCustomApp) {
          this.config.additionalAbandonedCartReminder.isThirdMessageEnabled = value;
        } else {
          this.feautureType = "followup_reminder";
          this.sendOwnNumber();
        }
      });
      if (value === false) {
        this.config.additionalAbandonedCartReminder.isThirdMessageEnabled = value;
        this.updateConfig();
      }
    },
    updateConfig() {
      const automationConfig = { ...this.config };
      this.$store
        .dispatch("updateAutomationConfig", { requestParams: automationConfig })
        .then(() => {
          this.displayNotification("Settings updated");
          this.originalConfig = cloneDeep(this.config);
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    openOptinModal() {
      this.showModal = true;
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isAutomatedAbandonedVisited"
        }
      });
    },
    getCapLimitIncrease() {
      const url = `${process.env.VUE_APP_SERVER_URL}shopify/increasecap?storeid=${this.config.storeId}`;
      if (window.top) {
        window.top.location = url;
      } else {
        window.location.href = url;
      }
    },
    openCrisp() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        [
          "text",
          "Hi I am blocked from sending. I would like to know more about whatsapp api approval"
        ]
      ]);
    },
    customizeMessage(approvalType) {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        this.feautureType = "custom_template";
        this.showAdvancedPlanAlert = true;
      } else {
        if (
          approvalType === "abandoned_cart_2" ||
          approvalType === "abandoned_cart_3"
        ) {
          this.$store.dispatch("hasUsingCustomApp").then(response => {
            if (response.hasCustomApp) {
              this.templateApprovalType = approvalType;
              this.showTemplateApprovalForm = true;
            } else {
              this.sendOwnNumber();
            }
          });
        } else {
          this.templateApprovalType = approvalType;
          this.showTemplateApprovalForm = true;
        }
      }
    },
    sendOwnNumber(needOwnNumber) {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        if (needOwnNumber) {
          this.feautureType = "own_number";
        }
        this.showAdvancedPlanAlert = true;
      } else {
        this.showOwnNumberForm = true;
      }
    },
    getTemplateMessage(elementName) {
      const template = this.templates.find(
        template => template.elementName === elementName
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    getTemplate(elementName) {
      const template = this.templates.find(
        template => template.elementName === elementName
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template;
    }
  }
};
</script>

<style lang="scss" scoped></style>
